// import Vue from 'vue'
// import Router from 'vue-router'
// import login from '@/views/login/login'
// import index from '@/views/index'
// import psn from '@/views/Personal/psn'
// import managecar from '@/views/Delivery/managecar'
// import managecarinfo from '@/views/Delivery/managecarinfo'
// import deliveryReport from '@/views/Report/deliveryReport'
// import timestamp from '@/views/Driver/timestamp'

// import logindriver from '@/views/login/loginDriver'
// import track from '@/views/track'
// import carSchedule from '@/views/carSchedule'
// import pc from '@/views/pc'
// import carBooking from '@/views/carBooking'

// Vue.use(Router)

// export default new Router({
//   routes: [
//     { path: '/', name: 'login', component: login },
//     { path: '/index', name: 'index', component: index },
//     { path: '/Personal/psn', name: 'psn', component: psn },
//     { path: '/Delivery/managecar', name: 'managecar', component: managecar },
//     { path: '/Delivery/managecarinfo', name: 'managecarinfo', component: managecarinfo },
//     { path: '/Report/deliveryreport', name: 'deliveryReport', component: deliveryReport },
//     { path: '/Driver/timestamp', name: 'timestamp', component: timestamp },

//     { path: '/login', name: 'logindriver', component: logindriver },
//     { path: '/track', name: 'track', component: track },
//     { path: '/CarSchedule', name: 'carSchedule', component: carSchedule },
//     { path: '/pc', name: 'pc', component: pc },
//     { path: '/carBooking', name: 'carBooking', component: carBooking },
//   ]
// })

import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store' // Import your Vuex store
import { auth } from '@/firebase'
import { reportError } from '@/components/report'
// STAFF_ROLES rather than a fourth copy of the same literal: the roles that may
// rewrite a day's dispatch are the roles bookingRules already calls staff.
import R from '@/components/bookingRules'
// The same table mainMenu.vue and the home launcher draw from, so a page they
// show greyed out is a page this guard actually refuses.
import M from '@/components/menuRoutes'

// Lazy-loaded components for better performance
const login = () => import('@/views/login/login')
const index = () => import('@/views/index')
const psn = () => import('@/views/Personal/psn')
const drivers = () => import('@/views/Personal/drivers')
const managecar = () => import('@/views/Delivery/managecar')
const managecarinfo = () => import('@/views/Delivery/managecarinfo')
const monitor = () => import('@/views/Delivery/monitor')
const deliveryReport = () => import('@/views/Report/deliveryReport')
const timestamp = () => import('@/views/Driver/timestamp')
const track = () => import('@/views/track')
const carSchedule = () => import('@/views/carSchedule')
const pc = () => import('@/views/pc')
const carBooking = () => import('@/views/carBooking')
const bookingDate = () => import('@/views/bookingDate')
const orderSearch = () => import('@/views/orderSearch')
const dispatchPlan = () => import('@/views/dispatchPlan')
const upcountry = () => import('@/views/upcountry')
const PageNotFound = () => import('@/views/PageNotFound')

const driverPin = () => import('@/views/Driver/pin')
const driverCar = () => import('@/views/Driver/carPick')
const driverDayView = () => import('@/views/Driver/day')
const driverStop = () => import('@/views/Driver/stop')
const driverStation = () => import('@/views/Driver/stationReport')

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  // base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
  routes: [
    {
      path: '/',
      redirect: { name: 'login' }
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        public: true,
        title: 'Login'
      }
    },
    {
      // The old driver login. Kept as a redirect rather than deleted: a driver
      // may already have this URL on their home screen.
      path: '/driver-login',
      redirect: { name: 'driverPin' }
    },
    {
      path: '/index',
      name: 'index',
      component: index,
      meta: {
        requiresAuth: true,
        title: 'Home'
      }
    },
    {
      path: '/personal/profile',
      name: 'psn',
      component: psn,
      meta: {
        requiresAuth: true,
        title: 'My Profile',
        roles: ['administrator', 'admin']
      }
    },
    {
      // Creates driver accounts and PINs through admin-only callables; the same
      // two roles as assertAdmin in functions/index.js.
      path: '/personal/drivers',
      name: 'drivers',
      component: drivers,
      meta: {
        requiresAuth: true,
        title: 'พนักงานขับรถ',
        roles: ['administrator', 'admin']
      }
    },
    {
      // path: '/delivery/vehicles',
      path: '/delivery/managecar',
      name: 'managecar',
      component: managecar,
      meta: {
        requiresAuth: true,
        title: 'Manage Vehicles',
        roles: ['administrator','admin', 'manager','delivery']
      }
    },
    {
      // path: '/delivery/vehicle/:id',
      path: '/delivery/managecarinfo',
      name: 'managecarinfo',
      component: managecarinfo,
      props: true,
      meta: {
        requiresAuth: true,
        title: 'Vehicle Details',
        roles: ['administrator','admin', 'manager','delivery']
      }
    },
    {
      path: '/monitor',
      name: 'monitor',
      component: monitor,
      meta: {
        requiresAuth: true,
        // Where the trucks are, and who is driving them. Gated to the same
        // roles bookingRules calls staff -- a shop must never see the fleet.
        roles: R.STAFF_ROLES,
        title: 'กระดานติดตามรถ'
      }
    },
    {
      path: '/reports/delivery',
      // path: '/delivery/reports/deliveryreport',
      name: 'deliveryReport',
      component: deliveryReport,
      meta: {
        // requiresAuth: true,
        public: true,
        title: 'Delivery Reports',
        // roles: ['administrator','admin', 'manager','delivery'],
        forPrinting: true
      }
    },
    {
      // path: '/driver/timestamps',
      path: '/driver/timestamp',
      name: 'timestamp',
      component: timestamp,
      meta: {
        requiresAuth: true,
        title: 'Driver Timestamps',
        roles: ['driver']
      }
    },
    {
      path: '/track',
      name: 'track',
      component: track,
      meta: {
        requiresAuth: true,
        title: 'Live Tracking'
      }
    },
    {
      // path: '/schedule',
      path: '/carschedule',
      name: 'carSchedule',
      component: carSchedule,
      meta: {
        requiresAuth: true,
        title: 'Vehicle Schedule',
        roles: ['administrator','admin', 'manager','delivery']
      }
    },
    {
      path: '/bookingdate',
      name: 'bookingDate',
      component: bookingDate,
      meta: {
        requiresAuth: true,
        title: 'จองวันส่งสินค้า'
      }
    },
    {
      path: '/ordersearch',
      name: 'orderSearch',
      component: orderSearch,
      meta: {
        requiresAuth: true,
        title: 'ค้นหาการจอง'
      }
    },
    {
      path: '/dispatchplan',
      name: 'dispatchPlan',
      component: dispatchPlan,
      meta: {
        requiresAuth: true,
        // Writing a plan replaces the day's auto-assigned appointments in the
        // collection carBooking renders, so it is gated to the same roles
        // bookingRules calls staff -- the people who already may move any
        // booking to any date.
        roles: R.STAFF_ROLES,
        title: 'จัดรถอัตโนมัติ'
      }
    },
    {
      path: '/upcountry',
      name: 'upcountry',
      component: upcountry,
      meta: { requiresAuth: true, roles: R.STAFF_ROLES, title: 'รถใหญ่ต่างจังหวัด' }
    },
    {
      path: '/carbooking',
      name: 'carBooking',
      component: carBooking,
      meta: {
        requiresAuth: true,
        title: 'Vehicle Booking'
      }
    },
    {
      path: '/pc',
      name: 'pc',
      component: pc,
      meta: {
        requiresAuth: true,
        title: 'PC View'
      }
    },
    {
      path: '/driver',
      name: 'driverPin',
      component: driverPin,
      meta: {
        public: true,
        title: 'เข้าสู่ระบบคนขับ'
      }
    },
    {
      path: '/driver/car',
      name: 'driverCar',
      component: driverCar,
      meta: { requiresAuth: true, roles: ['driver'], title: 'เลือกรถ' }
    },
    {
      path: '/driver/day',
      name: 'driverDay',
      component: driverDayView,
      meta: { requiresAuth: true, roles: ['driver'], title: 'งานวันนี้' }
    },
    {
      path: '/driver/stop/:id',
      name: 'driverStop',
      component: driverStop,
      props: true,
      meta: { requiresAuth: true, roles: ['driver'], title: 'รายละเอียดงาน' }
    },
    {
      path: '/driver/report-station',
      name: 'driverStation',
      component: driverStation,
      meta: { requiresAuth: true, roles: ['driver'], title: 'แจ้งสถานีชาร์จ/ปั๊มแก๊ส' }
    },
    {
      path: '*',
      name: 'not-found',
      component: PageNotFound,
      meta: {
        title: 'Page Not Found'
      }
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  // Set page title
  document.title = to.meta.title || 'Default App Title'
  
  // Check if route requires authentication
  // if (to.matched.some(record => record.meta.requiresAuth && !record.meta.forPrinting)) {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const user = store.state.user // Get user from Vuex
    const userStatus = store.state.status // Get role from Vuex

    // console.log('Firebase currentUser:', auth.currentUser);
    // console.log('Navigating to:', to.name)
    // console.log('User:',store.state.user)
    // console.log('User status:', store.state.status)
    // console.log('Full route object:', to);
    // console.log('Matched routes:', to.matched);

    if (!user) {
      // Not logged in -- or not YET: on a cold load this guard runs before
      // Firebase has answered, so a signed-in user lands here too. Carry the
      // page they asked for; App.vue sends them on to it once auth resolves.
      const redirect = M.safeRedirect(to.fullPath)
      return next(redirect ? { name: 'login', query: { redirect } } : { name: 'login' })
    }

    // Check route roles if specified
    if (to.meta.roles && !to.meta.roles.includes(userStatus)) {
      return next({ name: 'index' }) // Or to a 'forbidden' page
    }

    // A driver has no home page. index.vue draws its cards from
    // menuRoutes.pagesForRole(), which offers a driver nothing, so a driver who
    // lands on index sees a blank screen. Every non-driver route sends them back
    // to their own.
    //
    // Match '/driver' itself or anything under '/driver/' -- a bare
    // indexOf('/driver') !== 0 test would also match a future staff page like
    // '/driverreport' or '/driver-schedule' and misroute it.
    const toPath = String(to.path)
    if (userStatus === 'driver' && toPath !== '/driver' && toPath.indexOf('/driver/') !== 0) {
      return next({ name: 'driverCar' })
    }

    // A page still in testing is listed for everyone -- so a shop is not surprised
    // by it later -- but only staff may open it. The home card and the menu entry
    // are drawn disabled from the same table; this is what makes typing the URL
    // fail too. Client-side only, like every gate here: Firestore rules are open,
    // so this stops the UI, not a determined client.
    if (!M.canOpenRoute(to.name, userStatus)) {
      return next({ name: 'index' })
    }

    // Verify Firebase token on protected routes
    try {
      const currentUser = auth.currentUser
      if (currentUser) {
        const idTokenResult = await currentUser.getIdTokenResult(true)
        store.commit('setRole', idTokenResult.claims.status || 'user')
      }
    } catch (error) {
      reportError('Token verification failed:', error)
      await auth.signOut()
      store.commit('clearUser')
      // A disabled or PIN-reset driver's refresh fails here, and they belong on
      // the PIN screen, as App.vue already decides for signed-out driver routes.
      const toPath = String(to.path)
      if (toPath === '/driver' || toPath.indexOf('/driver/') === 0) {
        return next({ name: 'driverPin' })
      }
      return next({ name: 'login' })
    }
  }

  // Prevent authenticated users from accessing auth pages
  if (to.matched.some(record => record.meta.public)) {  // <-- And here
    if (store.state.user) {
      return next({ name: 'index' } )
    }
  }

  next()
})


export default router
